import type {
  FlowReviewSortableColumn,
  ParamsGetMerchflowsReviews,
} from "@CommonApi/merchflows/reviews";

type CurrentMerchflowsSort = Pick<ParamsGetMerchflowsReviews, "sortBy" | "sortDirection">;

export const getNextMerchflowsSort = (
  currentSort: CurrentMerchflowsSort,
  sortKey: FlowReviewSortableColumn,
): CurrentMerchflowsSort => {
  if (currentSort.sortBy !== sortKey || !currentSort.sortDirection) {
    return {
      sortBy: sortKey,
      sortDirection: "asc",
    };
  }

  if (currentSort.sortDirection === "asc") {
    return {
      sortBy: sortKey,
      sortDirection: "desc",
    };
  }

  return {
    sortBy: undefined,
    sortDirection: undefined,
  };
};
